import type { APP_TYPE } from '@/src/general/enums/appTypes'
import { Cookie } from '@/src/general/utils/cookies/Cookie'

export const isIOSWebview = () => {
  const userAgent = navigator?.userAgent || ''
  return (
    Cookie.get<APP_TYPE>('isNative') !== undefined ||
    /(iPhone|iPod|iPad)(?!.*Safari)|(WebView)/i.test(userAgent) ||
    /HozanaAppli/i.test(userAgent)
  )
}
